import * as Phaser from "phaser";

export class DecorRoomItem extends Phaser.GameObjects.Sprite {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    frame?: string,
  ) {
    super(scene, x, y, texture, frame);
    this.setOrigin(0.5, 0.5);
  }
}
